import { get as getCookie } from 'es-cookie'
import ComponentBoxContent from 'src/model/component-box'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import ButtonOptionsModal from '../components/custom-plugins/actions/button-options-modal'
import axios from 'axios'
import URL from 'src/api/url'
import {
  removeAllDropAreas,
  removeDropAreaNarrow,
  replacedropAreaWideContent,
} from '../components/custom-plugins/simple-box/utils'
import Interaction from '../components/interaction-builder'
import { AI_INSTRUCTION } from 'src/reducers/course/type'
import AiLoading from '../components/ai-loading'
import { snackbarShowAction } from 'src/reducers/snackbar/action'
import {
  processStartAction,
  processStartEnd,
} from 'src/reducers/process/action'

import SnackbarMessage from 'src/model/snackbar'
import UserType from 'src/model/user-types'
import FreeAccountModal from '../components/interaction-builder/free-account-modal'
import CommunityFreeAccountModal from '../components/community-board-modal/free-account-modal'
import { track } from '@amplitude/analytics-browser'
import {
  generateCardAction,
  courseGetAction,
  getCourseCreationProgressAction,
  setCardCreationProgress,
} from 'src/reducers/course/action'
import IntercomEmbed from '../components/intercom-embed'
import box from '../data'
import SelectedBuilder from '../components/interaction-builder/selected-builder'
import ChatInterface from '../components/interaction-builder/chat-interface'

// Default game config for Pixel Quest
const DEFAULT_PIXEL_QUEST_CONFIG = {
  title: 'The Path of the Product Bridge',
  mapGrid: {
    _hide: true,
    _value: [
      1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
      1, 3, 3, 3, 1, 1, 1, 1, 1, 1,
      1, 1, 1, 3, 1, 1, 1, 1, 1, 1,
      1, 1, 1, 3, 3, 3, 3, 1, 1, 1,
      1, 1, 1, 1, 1, 1, 3, 1, 1, 1,
      1, 1, 3, 3, 3, 3, 3, 1, 1, 1,
      1, 1, 3, 1, 1, 1, 1, 1, 1, 1,
      1, 1, 3, 3, 3, 3, 1, 1, 1, 1,
      1, 1, 1, 1, 1, 3, 3, 9, 1, 1,
      1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    ],
  },
  startPosition: {
    _hide: true,
    _value: { x: 1, y: 1 },
  },
  config: {
    language: 'en',
    pathColor: '#374151',
    wallColor: '#111827',
    bgColor: '#020617',
    titleColor: '#facc15',
    exitText: 'EXIT',
    instructionText: 'ANSWER ALL MASTERS CORRECTLY TO UNLOCK THE EXIT',
    victoryText: 'QUEST COMPLETE!',
    gameOverText: 'GAME OVER',
    tryAgainText: 'TRY AGAIN',
  },
  npcs: [
    {
      id: 1,
      name: 'The Architect',
      spriteColor: '#3b82f6',
      position: { x: 3, y: 1 },
      question: 'Product Management acts as a bridge between which two historically misaligned groups?',
      options: {
        _type: 'radio',
        _options: [
          'Investors and Competitors',
          'Engineers and Business Leaders',
          'Project Managers and Designers',
          'HR and Marketing',
        ],
        _value: 'Engineers and Business Leaders',
      },
    },
    {
      id: 2,
      name: 'The Intersection Sage',
      spriteColor: '#ef4444',
      position: { x: 5, y: 3 },
      question: "According to the Intersection Model, what happens if you ignore the 'Technology' domain?",
      options: {
        _type: 'radio',
        _options: [
          'The company goes bankrupt',
          'Nobody uses the product',
          'The product cannot be built',
          'The product has no value proposition',
        ],
        _value: 'The product cannot be built',
      },
    },
    {
      id: 3,
      name: 'The Lean Strategist',
      spriteColor: '#10b981',
      position: { x: 4, y: 5 },
      question: 'What is the primary purpose of a Minimum Viable Product (MVP)?',
      options: {
        _type: 'radio',
        _options: [
          'To release a half-baked product quickly',
          'To save money on development costs',
          'To collect maximum validated learning with least effort',
          'To provide all features to early adopters',
        ],
        _value: 'To collect maximum validated learning with least effort',
      },
    },
    {
      id: 4,
      name: 'The Visionary Guide',
      spriteColor: '#f59e0b',
      position: { x: 4, y: 7 },
      question: 'Which of these is a key question asked by a Product Manager rather than a Project Manager?',
      options: {
        _type: 'radio',
        _options: [
          'How do we get this done by Friday?',
          'Should we build this?',
          'How do we allocate these resources?',
          'Is the budget adherence correct?',
        ],
        _value: 'Should we build this?',
      },
    },
  ],
}

export const getYouTubeEmbedUrl = url => {
  const patterns = {
    shortLink: /youtu\.be\/([a-zA-Z0-9_-]+)(?:\?(.*))?/,
    watchLink: /youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)(?:&(.*))?/,
    embedLink: /youtube\.com\/embed\/([a-zA-Z0-9_-]+)(?:\?(.*))?/,
    shareLink: /youtube\.com\/shorts\/([a-zA-Z0-9_-]+)(?:\?(.*))?/,
    liveLink: /youtube\.com\/live\/([a-zA-Z0-9_-]+)(?:\?(.*))?/,
  }

  const lowerUrl = url.replace(/^(https?:\/\/)?(www\.)?/i, '').toLowerCase()
  const originalUrl = url

  for (let type in patterns) {
    const match = lowerUrl.match(patterns[type])
    if (match && match[1]) {
      const originalMatch = originalUrl.match(new RegExp(patterns[type].source))
      const videoId = originalMatch[1]
      const params = match[2] || ''

      return `https://www.youtube.com/embed/${videoId}${params ? '?' + params : ''
        }`
    }
  }

  return null
}

export const getVimeoEmbedUrl = url => {
  const patterns = {
    standardLink: /vimeo\.com\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
    channelLink: /vimeo\.com\/channels\/[^/]+\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
    groupLink: /vimeo\.com\/groups\/[^/]+\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
    albumLink: /vimeo\.com\/album\/[^/]+\/video\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
    showcaseLink: /vimeo\.com\/showcase\/[^/]+\/video\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
    eventLink: /vimeo\.com\/event\/[^/]+\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
    embedLink: /player\.vimeo\.com\/video\/([0-9]+)(?:\/([^?]+))?(?:\?(.*))?/,
  }

  const lowerUrl = url.replace(/^(https?:\/\/)?(www\.)?/i, '').toLowerCase()
  const originalUrl = url

  for (let type in patterns) {
    const match = lowerUrl.match(patterns[type])
    if (match && match[1]) {
      const originalMatch = originalUrl.match(new RegExp(patterns[type].source))
      const videoId = originalMatch[1]
      const hash = match[2] || ''

      return `https://player.vimeo.com/video/${videoId}?h=${hash}`
    }
  }

  return null
}

export const checkIfInsideSimpleBox = (selection, editor) => {
  const position = selection.getFirstPosition()
  if (!position) return false

  // Get all ancestors of the current position
  const ancestors = position.getAncestors()

  // Check if any ancestor is a simple box
  return ancestors.some(ancestor => {
    // Check if the element is a section with simple-box class
    if (ancestor.name === 'simpleBox') {
      const classes = editor.model.schema.getAttributeProperties(
        ancestor,
        'class',
      )
      return classes
    }
    return false
  })
}

const wrapStringInPTag = embedUrl => {
  const hasHtmlTags = /<[^>]*>/g.test(embedUrl)

  if (!hasHtmlTags) {
    return `<p>${embedUrl}</p>`
  }

  return embedUrl
}

const measureIframeHeight = docHtml =>
  new Promise(resolve => {
    const editable = document.querySelector('.ck-editor__editable')
    const width = editable && editable.offsetWidth ? editable.offsetWidth : 800

    const probe = document.createElement('iframe')
    probe.style.position = 'absolute'
    probe.style.left = '-9999px'
    probe.style.top = '0'
    probe.style.visibility = 'hidden'
    probe.style.border = 'none'
    probe.style.width = width + 'px'
    probe.style.height = '0px'

    let settled = false
    const finish = () => {
      if (settled) return
      settled = true
      let height = 0
      try {
        const doc = probe.contentDocument
        height = doc ? doc.documentElement.scrollHeight : 0
      } catch (e) {
        height = 0
      }
      document.body.removeChild(probe)
      resolve(height)
    }

    probe.onload = () => {
      // Let layout settle (fonts/images already awaited by the load event)
      requestAnimationFrame(finish)
    }
    // Safety net if the document never fires load
    setTimeout(finish, 3000)

    document.body.appendChild(probe)
    probe.srcdoc = docHtml
  })

const buildIsolatedHtmlDocument = (userHtml, interactionCode) => {
  const heightScript =
    '<script>(function(){var code=' +
    JSON.stringify(interactionCode) +
    ';function send(){window.parent.postMessage({interactionCode:code,type:"SET_INSTRUCTION_HEIGHT",value:document.documentElement.scrollHeight},"*");}' +
    'window.addEventListener("load",send);window.addEventListener("resize",send);setInterval(send,1000);})();<' + '/script>'

  return (
    '<!DOCTYPE html><html><head><meta charset="utf-8">' +
    '<meta name="viewport" content="width=device-width, initial-scale=1">' +
    '<style>html,body{margin:0;padding:0;font-family:Inter,sans-serif;}' +
    'img,video,iframe{max-width:100%;}</style></head><body>' +
    userHtml +
    heightScript +
    '</body></html>'
  )
}

const RAW_HTML_EMBED_MARKER = '<!--html-embed:raw-->'

export const buildHtmlEmbedValue = async (userHtml, htmlMode) => {
  if (htmlMode !== 'isolated') {
    // A comment marker, not a wrapper element: it renders nothing and cannot
    // affect layout, but lets the edit handler tell our raw blocks apart from
    // other raw html content.
    return RAW_HTML_EMBED_MARKER + wrapStringInPTag(userHtml)
  }

  const interactionCode =
    'html_embed_' + Math.random().toString(36).substring(2, 10)
  const docHtml = buildIsolatedHtmlDocument(userHtml, interactionCode)
  const measuredHeight = await measureIframeHeight(docHtml)

  const iframe = document.createElement('iframe')
  iframe.srcdoc = docHtml
  iframe.style.width = '100%'
  iframe.style.height = measuredHeight + 'px'
  iframe.style.border = 'none'
  iframe.dataset.interactionCode = interactionCode
  iframe.dataset.htmlEmbed = 'isolated'
  // Keep the author's own markup around so the edit modal can prefill with what
  // they typed instead of the generated document.
  iframe.dataset.embedSource = encodeURIComponent(userHtml)

  return iframe.outerHTML
}

// Recognises the blocks we generate, so editing reopens the modal on the mode it
// was created with. Everything else — content from before this existed, iframely
// embeds, interactions — returns null and keeps CKEditor's own source editing.
export const readHtmlEmbedValue = value => {
  if (!value || typeof value !== 'string') return null

  if (value.trimStart().startsWith(RAW_HTML_EMBED_MARKER)) {
    return {
      mode: 'raw',
      source: value.trimStart().slice(RAW_HTML_EMBED_MARKER.length),
    }
  }

  const holder = document.createElement('div')
  holder.innerHTML = value

  const node = holder.querySelector('iframe[data-html-embed="isolated"]')
  if (!node) return null

  const encoded = node.dataset.embedSource
  if (!encoded) return null

  try {
    return { mode: 'isolated', source: decodeURIComponent(encoded) }
  } catch (e) {
    return null
  }
}

export const handleEmbedInsert = async (
  embedUrl,
  position,
  modalData,
  editor,
  writer,
  dropAreaWide,
  doubleClick,
  htmlMode = 'raw',
) => {
  let url

  const embedServices = [
    'canva',
    'synthesia',
    'googleServices',
    'webLink',
    'calendly',
    'scribe',
    'soundCloud',
    'spotify',
    'loom',
    'airtable',
    'h5p',
    'youtube',
    'thingLink',
  ]

  if (modalData.value === 'vimeo') {
    url = getVimeoEmbedUrl(embedUrl)
  } else if (modalData.value === 'html') {
    editor.editing.view.focus()

    const embedValue = await buildHtmlEmbedValue(embedUrl, htmlMode)

    editor.model.change(writer => {
      const simpleBoxWrapper = writer.createElement('simpleBoxWrapper')
      const simpleBox = writer.createElement('simpleBox')
      const column = writer.createElement('column')

      const htmlEmbed = writer.createElement('rawHtml', {
        value: embedValue,
      })

      editor.model.insertContent(simpleBoxWrapper, position)

      writer.append(simpleBox, simpleBoxWrapper)
      writer.append(column, simpleBox)
      writer.append(htmlEmbed, column)
      if (dropAreaWide !== undefined && dropAreaWide !== null) {
        writer.remove(dropAreaWide)
      }
    })

    const root = window.editor.model.document.getRoot()
    // Remove all existing drag areas first
    const dragAreas = Array.from(root.getChildren()).filter(
      child => child.name === 'dropAreaNarrow',
    )
    dragAreas.forEach(dragArea => {
      window.editor.model.change(writer => {
        writer.remove(dragArea)
      })
    })
  } else if (embedServices.includes(modalData.value)) {
    try {
      const response = await axios.post(URL.EMBED, {
        url: embedUrl,
      })
      // Check if the response contains the expected data
      if (response.status === 200) {
        editor.editing.view.focus()
        if (response.data.data.html !== null) {
          editor.model.change(writer => {
            const simpleBoxWrapper = writer.createElement('simpleBoxWrapper')
            const simpleBox = writer.createElement('simpleBox')
            const column = writer.createElement('column')

            const htmlEmbed = writer.createElement('rawHtml', {
              value: response.data.data.html,
            })

            editor.model.insertContent(simpleBoxWrapper, position)

            writer.append(simpleBox, simpleBoxWrapper)
            writer.append(column, simpleBox)
            writer.append(htmlEmbed, column)
            if (dropAreaWide !== undefined && dropAreaWide !== null) {
              writer.remove(dropAreaWide)
            }
          })
        } else {
          editor.model.change(writer => {
            const simpleBoxWrapper = writer.createElement('simpleBoxWrapper')
            const simpleBox = writer.createElement('simpleBox')
            const column = writer.createElement('column')

            const htmlEmbed = writer.createElement('rawHtml', {
              value: `<iframe class="iframe-player" src=${embedUrl}></iframe>`,
            })

            editor.model.insertContent(simpleBoxWrapper, position)

            writer.append(simpleBox, simpleBoxWrapper)
            writer.append(column, simpleBox)
            writer.append(htmlEmbed, column)
            if (dropAreaWide !== undefined && dropAreaWide !== null) {
              writer.remove(dropAreaWide)
            }
          })
        }
      } else {
        throw new Error('Invalid response format')
      }
    } catch (error) {
      console.error('Embed generation error:', error)
    }
  }

  let sampleHtml

  if (modalData.value === 'vimeo') {
    if (url !== null) {
      editor.model.change(writer => {
        sampleHtml = `
              <div class="simple-box-wrapper"> 
                <div class="simple-box">
                  <div class="column">
                    <p>
                      <iframe class="iframe-player" src=${url}></iframe>
                    </p>
                  </div>
                </div>
              </div>`

        const viewFragment = editor.data.processor.toView(sampleHtml)
        const modelFragment = editor.data.toModel(viewFragment)
        // Insert the model fragment into the editor at the current selection
        editor.model.insertContent(modelFragment, position)
        if (dropAreaWide !== undefined && dropAreaWide !== null) {
          writer.remove(dropAreaWide)
        }
      })
    } else {
      editor.execute('undo')
    }
  }

  // Remove all drop areas after embed insert
  setTimeout(() => {
    removeDropAreaNarrow(editor)
  }, 300)
  setTimeout(() => {
    removeAllDropAreas(editor)
  }, 500)
}
export const aiInstructionConfirmSelection = async (
  selectedData,
  sourceText,
  colors,
  setIsChatModalOpen,
) => {
  let streamHandlers = null

  setIsChatModalOpen(true)

  try {
    const response = await fetch(
      'https://ai-generation.minicoursegenerator.com/api/createInteractionSonnet55',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getCookie('token')}`,
        },
        body: JSON.stringify({
          selected_data: selectedData,
          source_text: sourceText,
          // font: fontFamily, // Bu parametreleri nasıl alacağınıza karar verin
          // language: language,
          background_color: colors.backgroundColor,
          primary_color: colors.primaryColor,
        }),
      },
    )

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    // Create a message ID for streaming
    const messageId = Date.now() + 1000

    // Start streaming response
    if (streamHandlers && streamHandlers.startStream) {
      streamHandlers.startStream(messageId)
    }

    // Handle stream response
    const reader = response.body.getReader()
    const decoder = new TextDecoder()
    let fullResponse = ''

    while (true) {
      const { done, value } = await reader.read()

      if (done) {
        break
      }

      // Decode chunk
      const chunk = decoder.decode(value, { stream: true })
      fullResponse += chunk

      // Update stream message
      if (streamHandlers && streamHandlers.updateStream) {
        streamHandlers.updateStream(chunk)
      }
    }

    // End streaming
    if (streamHandlers && streamHandlers.endStream) {
      streamHandlers.endStream()
    }
  } catch (error) {
    console.error('Stream error:', error)

    setIsChatModalOpen(false)
  }
}

export const aiInstructionConfirmSelectionJSON = async (
  selectedData,
  sourceText,
  position,
  editor,
  colors,
  dispatch,
  fontFamily,
  language,
) => {
  let streamHandlers = null

  const showLoadingModal = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.INFO,
          title: ``,
          buttons: [],
          hideCloseButton: false,
          component: (
            <ChatInterface
              onStreamResponse={handlers => {
                streamHandlers = handlers
              }}
              onSendMessage={(message, messageId) => {
                // Handle additional messages from the chat interface
                handleAdditionalMessage(message, messageId)
              }}
            />
          ),
          callback: () => { },
        }),
      ),
    )
  }

  // Handle additional messages sent from the chat interface
  const handleAdditionalMessage = async (message, messageId) => {
    try {
      const response = await fetch(
        'https://ai-generation.minicoursegenerator.com/api/createInteractionSonnet55',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getCookie('token')}`,
          },
          body: JSON.stringify({
            selected_data: selectedData,
            source_text: sourceText,
            additional_instruction: message, // New user message
            font: fontFamily,
            language: language,
            background_color: colors.backgroundColor,
            primary_color: colors.primaryColor,
          }),
        },
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      await processStreamResponse(response, messageId)
    } catch (error) {
      console.error('Additional message error:', error)
      if (streamHandlers && streamHandlers.endStream) {
        streamHandlers.endStream()
      }
      // Show error in chat
      if (streamHandlers && streamHandlers.updateStream) {
        streamHandlers.updateStream(
          '\n\n❌ Sorry, there was an error processing your request. Please try again.',
        )
        setTimeout(() => {
          if (streamHandlers && streamHandlers.endStream) {
            streamHandlers.endStream()
          }
        }, 1000)
      }
    }
  }

  // Process streaming response
  const processStreamResponse = async (response, messageId) => {
    if (streamHandlers && streamHandlers.startStream) {
      streamHandlers.startStream(messageId)
    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder()
    let accumulatedContent = ''

    try {
      while (true) {
        const { done, value } = await reader.read()

        if (done) break

        const chunk = decoder.decode(value, { stream: true })
        const lines = chunk.split('\n')

        for (const line of lines) {
          if (line.trim()) {
            try {
              const data = JSON.parse(line)

              if (data.type === 'content' && data.text) {
                // Update both chat and preview
                if (streamHandlers && streamHandlers.updateStream) {
                  streamHandlers.updateStream(data.text)
                }
                accumulatedContent += data.text
              } else if (data.type === 'complete') {
                // Stream complete
                if (streamHandlers && streamHandlers.endStream) {
                  streamHandlers.endStream()
                }
                return accumulatedContent
              } else if (data.type === 'error') {
                throw new Error(data.message || 'Stream error occurred')
              }
            } catch (parseError) {
              // If not JSON, treat as regular text
              if (streamHandlers && streamHandlers.updateStream) {
                streamHandlers.updateStream(line)
              }
              accumulatedContent += line
            }
          }
        }
      }

      // End stream if not already ended
      if (streamHandlers && streamHandlers.endStream) {
        streamHandlers.endStream()
      }

      return accumulatedContent
    } catch (error) {
      console.error('Stream processing error:', error)
      if (streamHandlers && streamHandlers.endStream) {
        streamHandlers.endStream()
      }
      throw error
    }
  }

  // Show the modal first
  showLoadingModal()

  try {
    // Initial request
    const response = await fetch(
      'https://ai-generation.minicoursegenerator.com/api/createInteractionSonnet55',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getCookie('token')}`,
        },
        body: JSON.stringify({
          selected_data: selectedData,
          source_text: sourceText,
          font: fontFamily,
          language: language,
          background_color: colors.backgroundColor,
          primary_color: colors.primaryColor,
        }),
      },
    )

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const messageId = Date.now() + 1000
    const finalContent = await processStreamResponse(response, messageId)
  } catch (error) {
    console.error('Stream error:', error)

    dispatch(messageBoxHideAction())

    dispatch(
      snackbarShowAction(
        new SnackbarMessage(`error_${Date.now()}`, 'error', [
          'A technical issue has occurred. Please try again.',
        ]),
      ),
    )
  }
}

// Optional: Helper function to extract clean HTML from the response
export const extractCleanHTML = content => {
  // Remove markdown code blocks
  let cleanHTML = content.replace(/```html\n/g, '').replace(/\n```/g, '')

  // If it doesn't have DOCTYPE, html, or body tags, wrap it
  if (!cleanHTML.includes('<!DOCTYPE') && !cleanHTML.includes('<html')) {
    cleanHTML = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Generated Content</title>
</head>
<body>
    ${cleanHTML}
</body>
</html>`
  }

  return cleanHTML
}

// Optional: Helper function to save the generated HTML
export const saveGeneratedHTML = (
  htmlContent,
  filename = 'generated-content.html',
) => {
  const blob = new Blob([htmlContent], { type: 'text/html' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
// Matches the height script added on save, in its original or single-line form
const IFRAME_HEIGHT_SCRIPT_PATTERN = /(?:<!--\s*Script for responsive iframe height\s*-->\s*)?<script\b[^>]*>(?:(?!<\/script>)[\s\S])*?SET_INSTRUCTION_HEIGHT(?:(?!<\/script>)[\s\S])*?<\/script>/gi

// Edited interactions already carry the height script from their last save,
// so drop every existing one and add a single new script.
// Comments use /* */ so the script still runs if the HTML ends up on one line.
const withIframeHeightScript = (htmlContent, interactionCode) =>
  htmlContent.replace(IFRAME_HEIGHT_SCRIPT_PATTERN, '').replace(
    '</body>',
    `
        <!-- Script for responsive iframe height -->
        <script>
          /* Adjust iframe height when the content changes */
          function adjustIframeHeight() {
            const height = document.body.scrollHeight;
            const interactionCode = '${interactionCode}';

            /* Send message to parent window */
            window.parent.postMessage(
              {
                interactionCode: interactionCode,
                type: 'SET_INSTRUCTION_HEIGHT',
                value: height,
              },
              '*'
            );
          }

          /* Run on page load and resize, and periodically to catch dynamic content changes */
          window.addEventListener('load', adjustIframeHeight);
          window.addEventListener('resize', adjustIframeHeight);
          setInterval(adjustIframeHeight, 1000);
        </script>
      </body>`,
  )

export const aiInteractionEndModeEdit = (
  editor,
  htmlContent,
  position,
  elementToReplace = null,
) => {
  let insertPosition = null
  let existingWrapperAttributes = {} // Store existing wrapper attributes

  editor.model.change(writer => {
    if (elementToReplace) {
      let elementToRemove = elementToReplace

      while (elementToRemove && elementToRemove.name !== 'simpleBoxWrapper') {
        elementToRemove = elementToRemove.parent
      }

      if (elementToRemove && elementToRemove.name === 'simpleBoxWrapper') {
        // Capture existing attributes before removal
        existingWrapperAttributes = {
          backgroundImage:
            elementToRemove.getAttribute('backgroundImage') || '',
          backgroundColor:
            elementToRemove.getAttribute('backgroundColor') || '',
          backgroundType: elementToRemove.getAttribute('backgroundType') || '',
          backgroundPosition:
            elementToRemove.getAttribute('backgroundPosition') || '',
          backgroundSize: elementToRemove.getAttribute('backgroundSize') || '',
          sizeType: elementToRemove.getAttribute('sizeType') || '',
          overlayColor: elementToRemove.getAttribute('overlayColor') || '',
          linearValue: elementToRemove.getAttribute('linearValue') || '',
          opacity: elementToRemove.getAttribute('opacity') || '',
          useImageOverlay:
            elementToRemove.getAttribute('useImageOverlay') || '',
        }

        insertPosition = writer.createPositionBefore(elementToRemove)
        writer.remove(elementToRemove)
      } else {
        insertPosition = writer.createPositionBefore(elementToReplace)
        writer.remove(elementToReplace)
      }
    } else if (
      position &&
      position.parent &&
      position.parent.name === 'simpleBoxWrapper'
    ) {
      // Capture existing attributes from parent wrapper
      existingWrapperAttributes = {
        backgroundImage: position.parent.getAttribute('backgroundImage') || '',
        backgroundColor: position.parent.getAttribute('backgroundColor') || '',
        backgroundType: position.parent.getAttribute('backgroundType') || '',
        backgroundPosition:
          position.parent.getAttribute('backgroundPosition') || '',
        backgroundSize: position.parent.getAttribute('backgroundSize') || '',
        sizeType: position.parent.getAttribute('sizeType') || '',
        overlayColor: position.parent.getAttribute('overlayColor') || '',
        linearValue: position.parent.getAttribute('linearValue') || '',
        opacity: position.parent.getAttribute('opacity') || '',
        useImageOverlay: position.parent.getAttribute('useImageOverlay') || '',
      }

      insertPosition = writer.createPositionBefore(position.parent)
      writer.remove(position.parent)
    } else {
      insertPosition =
        position || editor.model.document.selection.getFirstPosition()
    }
  })

  // Generate a random instruction code for uniqueness
  const randomInstructionCode =
    'math_eq_' + Math.random().toString(36).substring(2, 10)

  const modifiedHtml = withIframeHeightScript(
    htmlContent,
    randomInstructionCode,
  )

  const calculateHeight = html => {
    const tempDiv = document.createElement('div')

    tempDiv.style.position = 'absolute'
    tempDiv.style.visibility = 'hidden'
    tempDiv.style.width = '100%'
    tempDiv.style.maxWidth = '800px'
    tempDiv.style.overflow = 'auto'
    tempDiv.style.fontSize = '16px'
    tempDiv.style.lineHeight = '1.5'

    tempDiv.innerHTML = html

    const images = tempDiv.getElementsByTagName('img')
    let imageLoadPromises = []

    for (let i = 0; i < images.length; i++) {
      if (!images[i].complete) {
        const promise = new Promise(resolve => {
          images[i].onload = resolve
          images[i].onerror = resolve
        })
        imageLoadPromises.push(promise)
      }
    }

    document.body.appendChild(tempDiv)

    return Promise.all(imageLoadPromises).then(() => {
      const scrollH = tempDiv.scrollHeight
      const offsetH = tempDiv.offsetHeight
      const clientH = tempDiv.clientHeight

      const contentHeight = Math.max(scrollH, offsetH, clientH)

      document.body.removeChild(tempDiv)

      return Math.max(500, contentHeight + 150) + 'px'
    })
  }

  calculateHeight(modifiedHtml)
    .then(iframeHeight => {
      editor.editing.view.focus()
      editor.model.change(writer => {
        if (!insertPosition || !insertPosition.root) {
          console.warn('Insert position invalid, using current selection')
          insertPosition = editor.model.document.selection.getFirstPosition()

          if (!insertPosition || !insertPosition.root) {
            const root = editor.model.document.getRoot()
            insertPosition = writer.createPositionAt(root, 'end')
          }
        }

        // Create the iframe element
        const iframe = document.createElement('iframe')
        iframe.srcdoc = modifiedHtml
        iframe.style.width = '100%'
        iframe.style.height = iframeHeight
        iframe.style.border = 'none'
        iframe.dataset.interactionCode = randomInstructionCode

        // Create the HTML embed element
        const htmlEmbed = writer.createElement('rawHtml', {
          value: iframe.outerHTML,
        })

        // Create the simpleBox and append the htmlEmbed to it
        const simpleBox = writer.createElement('simpleBox', {
          blockType: 'interactionBuilder',
        })

        const column = writer.createElement('column')
        writer.append(column, simpleBox)
        writer.append(htmlEmbed, column)

        // Create the wrapper with existing attributes (if any) and append the simpleBox to it
        const wrapperAttributes = {
          ...existingWrapperAttributes, // Spread existing attributes
        }

        // Only include attributes that have actual values
        Object.keys(wrapperAttributes).forEach(key => {
          if (!wrapperAttributes[key]) {
            delete wrapperAttributes[key]
          }
        })

        const simpleBoxWrapper = writer.createElement(
          'simpleBoxWrapper',
          wrapperAttributes,
        )
        writer.append(simpleBox, simpleBoxWrapper)

        // Insert the complete structure at the position
        try {
          editor.model.insertContent(simpleBoxWrapper, insertPosition)
        } catch (error) {
          console.error('Error inserting new element:', error)

          // Fallback: root'un sonuna ekle
          const root = editor.model.document.getRoot()
          const fallbackPosition = writer.createPositionAt(root, 'end')
          editor.model.insertContent(simpleBoxWrapper, fallbackPosition)
        }
      })
    })
    .catch(error => {
      console.error('Error in calculateHeight:', error)
    })

  track('interactive_activity_successful')

  // Remove all drop areas after interaction insert
  setTimeout(() => {
    removeDropAreaNarrow(editor)
  }, 300)
  setTimeout(() => {
    removeAllDropAreas(editor)
  }, 500)
}
export const aiInteractionEnd = (editor, htmlContent, position) => {
  // Generate a random instruction code for uniqueness
  const randomInstructionCode =
    'math_eq_' + Math.random().toString(36).substring(2, 10)

  const modifiedHtml = withIframeHeightScript(
    htmlContent,
    randomInstructionCode,
  )

  const calculateHeight = html => {
    const tempDiv = document.createElement('div')

    tempDiv.style.position = 'absolute'
    tempDiv.style.visibility = 'hidden'
    tempDiv.style.width = '100%'
    tempDiv.style.maxWidth = '800px'
    tempDiv.style.overflow = 'auto'
    tempDiv.style.fontSize = '16px'
    tempDiv.style.lineHeight = '1.5'

    tempDiv.innerHTML = html

    const images = tempDiv.getElementsByTagName('img')
    let imageLoadPromises = []

    for (let i = 0; i < images.length; i++) {
      if (!images[i].complete) {
        const promise = new Promise(resolve => {
          images[i].onload = resolve
          images[i].onerror = resolve
        })
        imageLoadPromises.push(promise)
      }
    }

    document.body.appendChild(tempDiv)

    return Promise.all(imageLoadPromises).then(() => {
      const scrollH = tempDiv.scrollHeight
      const offsetH = tempDiv.offsetHeight
      const clientH = tempDiv.clientHeight

      const contentHeight = Math.max(scrollH, offsetH, clientH)

      document.body.removeChild(tempDiv)

      return Math.max(500, contentHeight + 150) + 'px'
    })
  }

  calculateHeight(modifiedHtml).then(iframeHeight => {
    editor.editing.view.focus()
    editor.model.change(writer => {
      const simpleBoxWrapper = writer.createElement('simpleBoxWrapper')
      const simpleBox = writer.createElement('simpleBox', {
        blockType: 'interactionBuilder',
      })
      const column = writer.createElement('column')

      const iframe = document.createElement('iframe')

      // Set the srcdoc attribute with the modified HTML content
      iframe.srcdoc = modifiedHtml

      // Set the inline styles
      iframe.style.width = '100%'
      iframe.style.height = iframeHeight
      iframe.style.border = 'none'

      // Set data attribute with the instruction code for identification
      iframe.dataset.interactionCode = randomInstructionCode

      const htmlEmbed = writer.createElement('rawHtml', {
        value: iframe.outerHTML, // Convert the iframe element to HTML string
      })

      editor.model.insertContent(simpleBoxWrapper, position)
      writer.append(simpleBox, simpleBoxWrapper)
      writer.append(column, simpleBox)
      writer.append(htmlEmbed, column)
    })
  })

  track('interactive_activity_successful')

  // Remove all drop areas after interaction insert
  setTimeout(() => {
    removeDropAreaNarrow(editor)
  }, 300)
  setTimeout(() => {
    removeAllDropAreas(editor)
  }, 500)
}
export const handleAddImageHotspot = (
  position,
  editor,
  imageData,
  writer = null,
  dropAreaWide = null,
) => {
  try {
    editor.editing.view.focus()

    editor.model.change(writer => {
      // Create the structure: simpleBoxWrapper > simpleBox > column > imageHotspotContainer
      const simpleBoxWrapper = writer.createElement('simpleBoxWrapper')
      const simpleBox = writer.createElement('simpleBox')
      const column = writer.createElement('column', { 'flex-size': '1' })

      // Generate unique IDs
      const containerId = `hotspot-container-${Date.now()}`
      const hotspotId = `hotspot-${Date.now()}-${Math.random()
        .toString(36)
        .substr(2, 9)}`

      // Create image hotspot container with proper attributes
      const hotspotContainer = writer.createElement('imageHotspotContainer', {
        src:
          'https://cdn.minicoursegenerator.com/assets/carousel-and-hotspot/carouselAndHotspotImage.png' ||
          '',
        alt: 'Hotspot Image',
        id: containerId,
      })

      // ✅ Create default hotspot (the marker on the image)
      const defaultHotspot = writer.createElement('imageHotspot', {
        x: '60',
        y: '42',
        title: 'Hotspot',
        id: hotspotId,
        isVisible: 'false',
        backgroundColor: '#015FFB',
        iconColor: '#ffffff',
        icon: '',
        iconName: 'mdi:plus',
      })

      // ✅ Create default hotspot content (the popup content)
      const hotspotContent = writer.createElement('imageHotspotContent', {
        hotspotId: hotspotId, // Match with hotspot ID
      })

      // ✅ Create default content structure inside hotspot content
      const contentWrapper = writer.createElement('simpleBoxWrapper')
      const contentSimpleBox = writer.createElement('simpleBox')
      const contentColumn = writer.createElement('column', { 'flex-size': '1' })

      // Create heading
      const heading = writer.createElement('heading2')
      writer.insertText('Heading', heading)

      // Create paragraph
      const paragraph = writer.createElement('paragraph')
      writer.insertText(
        "I'm a paragraph. Click to start writing that will inform, inspire, or encourage your community. We know you have so many things to share with the world. Happy editing!",
        paragraph,
      )

      // Assemble content structure
      writer.append(heading, contentColumn)
      writer.append(paragraph, contentColumn)
      writer.append(contentColumn, contentSimpleBox)
      writer.append(contentSimpleBox, contentWrapper)
      writer.append(contentWrapper, hotspotContent)

      // ✅ Append hotspot and content as siblings to container
      writer.append(defaultHotspot, hotspotContainer)
      writer.append(hotspotContent, hotspotContainer)

      // Build the main structure
      writer.append(heading, column)
      writer.append(hotspotContainer, column)
      writer.append(column, simpleBox)
      writer.append(simpleBox, simpleBoxWrapper)

      // Insert at position
      editor.model.insertContent(simpleBoxWrapper, position)

      // Remove drop area if provided
      if (dropAreaWide !== undefined && dropAreaWide !== null) {
        writer.remove(dropAreaWide)
      }

      // Set selection to the new container
      writer.setSelection(hotspotContainer, 'on')
    })

    // Track the event
    track('image_hotspot_added')

    // Remove all drop areas after adding hotspot
    setTimeout(() => {
      removeDropAreaNarrow(editor)
    }, 300)
    setTimeout(() => {
      removeAllDropAreas(editor)
    }, 500)
  } catch (error) {
    console.error('Image hotspot insert error:', error)
  }
}
export const handleAddCommunityBoard = (
  position,
  editor,
  dispatch,
  CommunityBoardModal,
  writer,
  dropAreaWide,
) => {
  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: `<div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
              <Typography style="margin-left: 8; color: #002E47; font-weight: 400; font-size: 16px;">
                Community Board
              </Typography>
            </div>`,
        buttons: [],
        maxWidth: '480px',
        component: (
          <CommunityBoardModal
            onConfirm={boardData => {
              handleCommunityBoardInsert(
                boardData,
                position,
                editor,
                writer,
                dropAreaWide,
              )
              dispatch(messageBoxHideAction())
            }}
            onCancel={() => {
              dispatch(messageBoxHideAction())
              editor.execute('undo')
              setTimeout(() => {
                removeDropAreaNarrow(editor)
              }, 300)
              setTimeout(() => {
                removeAllDropAreas(editor)
              }, 500)
            }}
          />
        ),
        callback: () => {
          editor.execute('undo')
          setTimeout(() => {
            removeDropAreaNarrow(editor)
          }, 300)
          setTimeout(() => {
            removeAllDropAreas(editor)
          }, 500)
        },
      }),
    ),
  )

}

export const handleAddCommunityBoardFreeAccount = (editor, dispatch) => {
  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: `
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                  "
                >
                <Typography
                  style="
                    color: var(--mcg-dark, #002E47);
                    font-family: Inter;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 150%;
                  "
                >
                  Community Board
                </Typography>
              </div>`,

        buttons: [],
        component: <CommunityFreeAccountModal />,
        callback: () => {
          editor.execute('undo')
          setTimeout(() => {
            removeDropAreaNarrow(editor)
          }, 300)
          setTimeout(() => {
            removeAllDropAreas(editor)
          }, 500)
        },
      }),
    ),
  )

}

const handleCommunityBoardInsert = (
  boardData,
  position,
  editor,
  writer,
  dropAreaWide,
) => {
  try {
    editor.editing.view.focus()

    editor.model.change(writer => {
      const simpleBoxWrapper = writer.createElement('simpleBoxWrapper', {
        layoutType: 'wide',
      })
      const simpleBox = writer.createElement('simpleBox')
      const column = writer.createElement('column')

      // Create community block element with board data
      const communityBlock = writer.createElement('communityBlock', {
        data: JSON.stringify(boardData),
        id: boardData.boardId || `board-${Date.now()}`,
        moderation: 'aiAuto',
        visitorPermissions: 'write',
        communityId: boardData.id,
      })

      editor.model.insertContent(simpleBoxWrapper, position)

      writer.append(simpleBox, simpleBoxWrapper)
      writer.append(column, simpleBox)
      writer.append(communityBlock, column)

      if (dropAreaWide !== undefined && dropAreaWide !== null) {
        writer.remove(dropAreaWide)
      }
    })

    // Remove all drop areas after community board insert
    setTimeout(() => {
      removeDropAreaNarrow(editor)
    }, 300)
    setTimeout(() => {
      removeAllDropAreas(editor)
    }, 500)
  } catch (error) {
    console.error('Community board insert error:', error)
  }
}

export const handleAddEmbed = (
  modalData,
  position,
  editor,
  dispatch,
  Embed,
  writer,
  dropAreaWide,
  doubleClick,
) => {
  const embedCallback = () => {
    editor.execute('undo')
    setTimeout(() => {
      removeDropAreaNarrow(editor)
    }, 300)
    setTimeout(() => {
      removeAllDropAreas(editor)
    }, 500)
  }

  const handleEmbedCallback = (url, htmlMode) => {
    handleEmbedInsert(
      url,
      position,
      modalData,
      editor,
      writer,
      dropAreaWide,
      doubleClick,
      htmlMode,
    )
    dispatch(messageBoxHideAction())
  }

  if (modalData.value === 'intercom') {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          title: ``,
          buttons: [],
          component: (
            <IntercomEmbed
              onEmbed={(articleId, questionCount) => {
                editor.editing.view.focus()
                editor.model.change(writer => {
                  const simpleBoxWrapper = writer.createElement('simpleBoxWrapper', {
                    intercomArticleId: articleId,
                  })
                  const simpleBox = writer.createElement('simpleBox')
                  const column = writer.createElement('column')
                  const htmlEmbed = writer.createElement('rawHtml', {
                    value: '<p>Loading Intercom article...</p>',
                  })
                  editor.model.insertContent(simpleBoxWrapper, position)
                  writer.append(simpleBox, simpleBoxWrapper)
                  writer.append(column, simpleBox)
                  writer.append(htmlEmbed, column)
                  if (dropAreaWide) {
                    writer.remove(dropAreaWide)
                  }
                })
                const root = editor.model.document.getRoot()
                const dragAreas = Array.from(root.getChildren()).filter(
                  child => child.name === 'dropAreaNarrow',
                )
                dragAreas.forEach(dragArea => {
                  editor.model.change(writer => {
                    writer.remove(dragArea)
                  })
                })
                if (questionCount <= 0) {
                  dispatch(messageBoxHideAction())
                } else {
                  dispatch(setCardCreationProgress(true))
                }
                // Fetch article content immediately
                const editorRef = window.editor || editor
                const course = editorRef.config.get('simpleBox.course') || {}
                const courseId = course.id || ''
                const endpoint = URL.API + 'intercom/articles/' + articleId + '/course/' + courseId
                const setArticleContent = (content) => {
                  const editorRoot = editorRef.model.document.getRoot()
                  for (const child of editorRoot.getChildren()) {
                    if (child.name !== 'simpleBoxWrapper') continue
                    if (child.getAttribute('intercomArticleId') !== articleId) continue
                    editorRef.model.change(w => {
                      for (const sb of child.getChildren()) {
                        if (sb.name !== 'simpleBox') continue
                        for (const col of sb.getChildren()) {
                          if (col.name !== 'column') continue
                          for (const rh of col.getChildren()) {
                            if (rh.name !== 'rawHtml') continue
                            w.setAttribute('value', content, rh)
                          }
                        }
                      }
                    })
                  }
                }
                axios.get(endpoint).then(response => {
                  const articleData = response?.data?.data || response?.data
                  const body = articleData?.body
                  if (!body) {
                    setArticleContent('<p>No content found</p>')
                    return
                  }
                  const title = articleData?.title || ''
                  const description = articleData?.description || ''
                  let fullBody = body
                    .replace(/<iframe[^>]*src="https?:\/\/(?:www\.)?youtube\.com\/embed\/([^"?]+)[^"]*"[^>]*>(?:<\/iframe>)?/gi,
                      (match, videoId) => '<a href="https://www.youtube.com/watch?v=' + videoId + '" target="_blank" style="display:block"><img src="https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg" style="max-width:100%;height:auto;border-radius:8px;" /></a>')
                  if (description) {
                    fullBody = '<p class="no-margin" style="font-size:14px;color:#637381">' + description + '</p><hr>' + fullBody
                  }
                  if (title) {
                    fullBody = '<h1>' + title + '</h1>' + fullBody
                  }
                  setArticleContent(fullBody)
                  // Generate quiz if requested
                  if (questionCount > 0) {
                    const plainText = body.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
                    const urlParts = window.location.pathname.split('/')
                    const pageIdx = urlParts.indexOf('page')
                    const currentPageId = pageIdx !== -1 ? urlParts[pageIdx + 1] : ''
                    let sectionId = null
                    let startingOrder = 0
                    const courseSections = course.sections || []
                    for (const section of courseSections) {
                      const card = (section.cards || []).find(c => String(c.id) === String(currentPageId))
                      if (card) {
                        sectionId = section.id
                        startingOrder = card.orderOfCard + 1
                        break
                      }
                    }
                    const checkQuizProgress = (quizCourseId, generatedCardId, interval) => {
                      dispatch(
                        getCourseCreationProgressAction(quizCourseId, progressResponse => {
                          if (progressResponse.cardCreationProgress >= 100) {
                            dispatch(
                              courseGetAction(quizCourseId, () => {
                                clearInterval(interval)
                                dispatch(setCardCreationProgress(false))
                              }),
                            )
                          }
                        }),
                      )
                    }
                    dispatch(generateCardAction({
                      courseId: courseId,
                      sectionId: sectionId,
                      startingOrder: startingOrder,
                      count: questionCount,
                      contentType: 1,
                      sourceType: 0,
                      prompt: plainText,
                      attachments: null,
                      sourceSections: null,
                    }, response => {
                      if (response && response[0]) {
                        const cardId = response[0].cardId
                        if (cardId) {
                          dispatch(setCardCreationProgress(true))
                          const progressInterval = setInterval(() => {
                            checkQuizProgress(courseId, cardId, progressInterval)
                          }, 1000)
                        }
                      }
                    }))
                  }
                }).catch(() => {
                  setArticleContent('<p>No content found</p>')
                })
              }}
            />
          ),
          callback: embedCallback,
        }),
      ),
    )
  } else {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          title: ``,
          buttons: [],
          component: (
            <Embed
              modalData={modalData}
              onEmbed={handleEmbedCallback}
            />
          ),
          callback: embedCallback,
        }),
      ),
    )
  }
}
export const removeIframesCompletely = data => {
  // Get content from the editor
  let content = data

  // Method 1: Using regular expression to remove iframe tags and their content
  content = content.replace(/<iframe\b[^>]*>[\s\S]*?<\/iframe>/gi, '')

  // Remove <div data-type="single-audio" ...>...</div> blocks (greedy)
  content = content.replace(
    /<div[^>]*data-type=["']single-audio["'][^>]*>[\s\S]*?<\/div>/gi,
    '',
  )

  // Method 2: Using DOM manipulation (more reliable for complex HTML)
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = content

  // Find and remove all iframes
  const iframes = tempDiv.querySelectorAll('iframe')
  iframes.forEach(iframe => {
    iframe.parentNode.removeChild(iframe)
  })

  // Find and remove all <div data-type="single-audio">
  const singleAudios = tempDiv.querySelectorAll('div[data-type="single-audio"]')
  singleAudios.forEach(audioDiv => {
    audioDiv.parentNode.removeChild(audioDiv)
  })

  // Get the cleaned content
  const cleanedContent = tempDiv.innerHTML

  // Return the cleaned content (you can use either method's result)
  // You can also use editor.setData(cleanedContent) to update the editor
  return cleanedContent
}
export const handleAddInterActive = (
  modalData,
  position,
  editor,
  dispatch,
  Embed,
  writer,
  dropAreaWide,
  doubleClick,
  fontFamily,
  language,
) => {
  const handleConfirmWithSelection = (selectedData, sourceText, colors) => {
    aiInstructionConfirmSelection(
      selectedData,
      sourceText,
      position,
      editor,
      colors,
      dispatch,
      fontFamily,
      language,
    )
  }
  const handleCancel = () => {
    dispatch(messageBoxHideAction())
  }

  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: `
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                  "
                >
                <Typography
                  style="
                    color: var(--mcg-dark, #002E47);
                    font-family: Inter;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 150%; 
                  "
                >
                  AI Interaction Builder
                </Typography>
              </div>`,
        draggable: false,
        maxWidth: '920px',
        maxHeight: '660px',
        buttons: [],
        component: (
          <SelectedBuilder
            position={position}
            editor={editor}
            fontFamily={fontFamily}
            language={language}
          />
        ),
        callback: () => {
          editor.execute('undo')
        },
      }),
    ),
  )

}
export const handleAddInterActiveFreeAccount = (editor, dispatch) => {
  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: `
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                  "
                >
                <Typography
                  style="
                    color: var(--mcg-dark, #002E47);
                    font-family: Inter;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 150%; 
                  "
                >
                  AI Interaction Builder
                </Typography>
              </div>`,

        buttons: [],
        component: <FreeAccountModal />,
        callback: () => {
          editor.execute('undo')
          setTimeout(() => {
            removeDropAreaNarrow(editor)
          }, 300)
          setTimeout(() => {
            removeAllDropAreas(editor)
          }, 500)
        },
      }),
    ),
  )
}

export const handleEditorReady = (
  editorRef,
  onDropClose,
  dispatch,
  Embed,
  CommunityBoardModal,
) => {
  return editor => {
    editorRef.current = editor

    document.querySelectorAll('video').forEach(videoElement => {
      videoElement.addEventListener('click', function (e) {
        const clickedVideo = e.currentTarget

        if (clickedVideo.paused) {
          clickedVideo.play()
        } else {
          clickedVideo.pause()
        }
      })
    })

    window.editor = editor
    editor.conversion.for('upcast').add(dispatcher => {
      dispatcher.on('element:a', (evt, data, conversionApi) => {
        try {
          const viewLink = data.viewItem
          const modelRange = data.modelRange

          if (!viewLink || !modelRange) {
            return
          }

          if (
            typeof viewLink.hasClass !== 'function' ||
            typeof viewLink.findAncestor !== 'function'
          ) {
            return
          }

          const isButton =
            viewLink.hasClass('simple-button') ||
            viewLink.findAncestor('div[class*="button-wrapper"]')

          if (isButton) {
            evt.stop()
            return
          }

          if (
            typeof viewLink.hasAttribute !== 'function' ||
            typeof viewLink.getAttribute !== 'function'
          ) {
            return
          }

          if (!viewLink.hasAttribute('href')) {
            return
          }

          const href = viewLink.getAttribute('href')

          if (!href || typeof href !== 'string') {
            return
          }

          const writer = conversionApi.writer

          let linkText = ''
          try {
            if (typeof viewLink.getChildren === 'function') {
              const children = viewLink.getChildren()
              if (children && typeof children[Symbol.iterator] === 'function') {
                linkText = Array.from(children)
                  .map(child => {
                    if (child && typeof child.data === 'string') {
                      return child.data
                    }
                    return ''
                  })
                  .join('')
              }
            }
          } catch (childError) {
            console.warn('Link text alınırken hata:', childError)
            linkText = ''
          }

          if (writer && modelRange) {
            writer.setAttribute('linkHref', href, modelRange)
            writer.setAttribute('linkText', linkText, modelRange)
            // Handle decorator attributes during upcast                                                                                                           
            if (viewLink.hasAttribute('target') && viewLink.getAttribute('target') === '_blank') {
              writer.setAttribute('linkOpenInNewTab', true, modelRange)
            }
          }
        } catch (error) {
          console.error('Link conversion sırasında hata:', error)
        }
      })
    })

    editor.conversion.for('editingDowncast').add(dispatcher => {
      dispatcher.on('attribute:linkHref', (evt, data, conversionApi) => {
        const { item } = data

        if (isInButton(item)) {
          evt.stop()
          return
        }
      })
    })

    editor.conversion.for('dataDowncast').add(dispatcher => {
      dispatcher.on('attribute:linkHref', (evt, data, conversionApi) => {
        const { item, attributeNewValue } = data

        if (isInButton(item)) {
          evt.stop()
          return
        }

        if (attributeNewValue) {
          const viewWriter = conversionApi.writer
          const originalText = item.getAttribute('linkText') || item.data

          // Build link attributes including decorator values                                                                                                  
          const linkAttributes = {
            href: attributeNewValue,
          }

          // Check for manual decorators from the link command                                                                                                 
          const linkCommand = editor.commands.get('link')
          if (linkCommand && linkCommand.manualDecorators) {
            for (const decorator of linkCommand.manualDecorators) {
              const decoratorValue = item.getAttribute(decorator.id)
              // Apply decorator attributes if the decorator is enabled                                                                                        
              if (decoratorValue) {
                Object.assign(linkAttributes, decorator.attributes)
              }
            }
          }

          const linkElement = viewWriter.createContainerElement('a', linkAttributes)

          viewWriter.insert(
            viewWriter.createPositionAt(linkElement, 0),
            viewWriter.createText(originalText),
          )
          conversionApi.consumable.consume(item, evt.name)
        }
      })
    })
    function isInButton(item) {
      let parent = item.parent
      while (parent) {
        if (
          parent.name === 'simpleButton' ||
          parent.name === 'buttonWrapper' ||
          parent.name === 'simpleIcon'
        ) {
          return true
        }
        parent = parent.parent
      }
      return false
    }

    editor.model.schema.extend('$text', {
      allowAttributes: ['linkHref', 'linkText', 'linkOpenInNewTab'],
    })
    const cleanupLinks = () => {
      const model = editor.model
      const root = model.document.getRoot()

      model.change(writer => {
        const range = writer.createRangeIn(root)

        for (const item of range.getItems()) {
          if (item.hasAttribute('linkHref')) {
            if (isInButton(item)) {
              writer.removeAttribute('linkHref', item)
              writer.removeAttribute('linkText', item)
            }
          }
        }
      })
    }

    cleanupLinks()
    editor.model.document.on('change:data', () => {
      cleanupLinks()
    })

    document.addEventListener('DOMContentLoaded', function () {
      const images = document.querySelectorAll('.column img')

      images.forEach(img => {
        img.setAttribute('draggable', 'false')

        img.addEventListener('dragstart', function (e) {
          e.preventDefault()
        })

        img.addEventListener('mousedown', function (e) {
          e.preventDefault()
        })
      })
    })

    const codeBlockPlugin = editor.plugins.get('CodeBlock')
    if (codeBlockPlugin) {
      codeBlockPlugin.clearForceDisabled()
    }
    // Add schema rules to allow links in paragraphs
    editor.model.schema.extend('$text', {
      allowAttributes: ['linkHref', 'linkType'],
    })
    editor.editing.view.document.on('delete', (evt, data) => {
      const selection = editor.model.document.selection
      const firstPosition = selection.getFirstPosition()

      // Handle both image and video wrappers
      const isMediaWrapper =
        firstPosition.parent.is('element', 'imageWrapper') ||
        firstPosition.parent.is('element', 'imageWrapperAspectRatio') ||
        firstPosition.parent.is('element', 'videoWrapper')

      if (isMediaWrapper) {
        editor.model.change(writer => {
          // Get the parent element (wrapper)
          const wrapper = firstPosition.parent

          // Get the position before the wrapper
          const positionBefore = writer.createPositionBefore(wrapper)

          // Remove the wrapper
          writer.remove(wrapper)

          // Set the selection to the position before where the wrapper was
          writer.setSelection(positionBefore)
        })

        // Prevent default deletion behavior
        data.preventDefault()
        evt.stop()
      }
    })

    editor.editing.view.document.on('drag', event => {
      event.preventDefault()
    })
    document.addEventListener('drag', event => {
      // const menu = document.getElementById('editor-drag-drop-menu')
      //menu.style.visibility = 'hidden'
      event.preventDefault()
    })
    document.addEventListener('drop', event => {
      event.preventDefault()
      //const menu = document.getElementById('editor-drag-drop-menu')
      //menu.style.visibility = 'visible'
    })

    // Editing one of our HTML blocks should reopen the same modal it was created
    // with, prefilled — CKEditor's own source editor exposes the generated iframe
    // document, so saving from there silently turned an isolated block into raw
    // markup.
    const handleHtmlEmbedEditClick = event => {
      const editButton =
        event.target &&
        event.target.closest &&
        event.target.closest('.raw-html-embed__edit-button')
      if (!editButton) return

      const widgetDom = editButton.closest('.raw-html-embed')
      if (!widgetDom) return

      let modelElement = null
      try {
        const viewElement = editor.editing.view.domConverter.mapDomToView(
          widgetDom,
        )
        modelElement = viewElement
          ? editor.editing.mapper.toModelElement(viewElement)
          : null
      } catch (e) {
        modelElement = null
      }

      if (!modelElement || modelElement.name !== 'rawHtml') return

      const parsed = readHtmlEmbedValue(modelElement.getAttribute('value'))
      if (!parsed) return // not ours — leave CKEditor's source editing alone

      event.preventDefault()
      event.stopPropagation()

      const htmlModalData = (
        (box.find(category => category.value === 'embed') || {}).options || []
      ).find(option => option.value === 'html')

      dispatch(
        messageBoxShowAction(
          MessageBoxContent({
            type: MessageBoxType.WARNING,
            title: ``,
            buttons: [],
            component: (
              <Embed
                modalData={htmlModalData}
                initialValue={parsed.source}
                initialMode={parsed.mode}
                submitLabel="Save"
                onEmbed={async (nextHtml, nextMode) => {
                  const nextValue = await buildHtmlEmbedValue(
                    nextHtml,
                    nextMode,
                  )
                  editor.model.change(writer => {
                    writer.setAttribute('value', nextValue, modelElement)
                  })
                  dispatch(messageBoxHideAction())
                }}
              />
            ),
          }),
        ),
      )
    }

    // onReady can run again (page switches, remounts); keep a single listener.
    if (window.__htmlEmbedEditHandler) {
      document.removeEventListener(
        'click',
        window.__htmlEmbedEditHandler,
        true,
      )
    }
    window.__htmlEmbedEditHandler = handleHtmlEmbedEditClick
    document.addEventListener('click', handleHtmlEmbedEditClick, true)

    const addClickListenerToEmbeds = editor => {
      const elements = document.querySelectorAll(
        '.ck-widget.raw-html-embed.ck-widget_with-selection-handle',
      )

      elements.forEach(element => {
        element.addEventListener('click', function (e) {
          const rect = this.getBoundingClientRect()
          const x = e.clientX - rect.left

          if (x >= rect.width - 22) {
            editor.model.change(writer => {
              const selection = editor.model.document.selection
              const rawHtml = selection.getSelectedElement()

              if (rawHtml && rawHtml.name === 'rawHtml') {
                writer.remove(rawHtml)
              }
            })
          }
        })
      })
    }

    // Create MutationObserver to watch for new elements
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          addClickListenerToEmbeds(editor)
        }
      })
    })

    // Start observing with configuration
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    // Initial setup
    addClickListenerToEmbeds(editor)

    editor.editing.view.document.on('paste', (evt, data) => {
      // Get the data from the paste event
      const htmlContent = data.dataTransfer.getData('text/html')

      if (htmlContent) {
        // Create a temporary div to hold the content
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = htmlContent

        // Remove all style attributes from all elements
        const elements = tempDiv.getElementsByTagName('*')
        for (let i = 0; i < elements.length; i++) {
          elements[i].removeAttribute('style')
          elements[i].removeAttribute('class')
        }

        // This handler stops the clipboard pipeline, so the editor's own link stripping never
        // sees HTML pastes. Plans without the link feature (Basic and trials) would otherwise
        // paste links straight in; keep the text and drop the link.
        const userRole = UserType[window.CONSTANTS.USER_ROLE_ID]
        if (userRole === 'Basic' || UserType.isTrialEquivalent(userRole)) {
          tempDiv.querySelectorAll('a').forEach(anchor => {
            anchor.replaceWith(...anchor.childNodes)
          })
          tempDiv.querySelectorAll('[href]').forEach(element => {
            element.removeAttribute('href')
          })
        }

        // Get the cleaned content
        const cleanedContent = tempDiv.innerHTML

        // Prevent the default paste behavior
        evt.stop()

        // Insert the cleaned content
        const viewFragment = editor.data.processor.toView(cleanedContent)
        const modelFragment = editor.data.toModel(viewFragment)
        editor.model.insertContent(modelFragment)
      }
    })

    // Prevent dragging over header/footer
    // Optimized dragover handler - direct, minimal operations
    editor.editing.view.document.on('dragover', (event, data) => {
      if (!data || !data.domEvent) return

      const domEvent = data.domEvent
      const clientY = domEvent.clientY

      // Get required elements with single queries
      const headerElement = document.querySelector('.editor-header')

      // Fast header check
      if (
        headerElement &&
        clientY <= headerElement.getBoundingClientRect().bottom
      ) {
        domEvent.preventDefault()
        event.stop()
        document.body.style.cursor = 'not-allowed'
        return
      }

      // Valid area
      document.body.style.cursor = 'auto'
    })

    // Optimized drop handler - direct, minimal operations
    // Updated dragover handler to allow dropping on footer area
    editor.editing.view.document.on('dragover', (event, data) => {
      if (!data || !data.domEvent) return

      const domEvent = data.domEvent
      const clientY = domEvent.clientY

      // Get required elements with single queries
      const headerElement = document.querySelector('.editor-header')

      // Fast header check
      if (headerElement) {
        try {
          if (clientY <= headerElement.getBoundingClientRect().bottom) {
            domEvent.preventDefault()
            event.stop()
            document.body.style.cursor = 'not-allowed'
            return
          }
        } catch (error) {
          console.warn('Header element access error:', error)
        }
      }

      // Valid area
      document.body.style.cursor = 'auto'
    })

    // Optimized drop handler - direct, minimal operations
    editor.editing.view.document.on('drop', (event, data) => {
      if (!data || !data.domEvent) return

      const domEvent = data.domEvent
      const clientY = domEvent.clientY
      const selectedElement = editor.model.document.selection
      // Quick header check
      const headerElement = document.querySelector('.editor-header')
      if (headerElement) {
        try {
          if (clientY <= headerElement.getBoundingClientRect().bottom) {
            domEvent.preventDefault()
            event.stop()
            document.body.style.cursor = 'not-allowed'
            return
          }
        } catch (error) {
          console.warn('Header element access error:', error)
        }
      }

      // Check if dropped on valid drop area
      const isValidDropArea = element => {
        if (!element) return false

        // Check element and its parents for drop-area classes
        let currentElement = element
        while (currentElement && currentElement !== document.body) {
          if (
            currentElement.classList?.contains('drop-area-wide') ||
            currentElement.classList?.contains('drop-area-narrow')
          ) {
            return true
          }
          currentElement = currentElement.parentElement
        }
        return false
      }

      const isValidDrop = isValidDropArea(domEvent.target)

      // Proceed with drop handling
      domEvent.preventDefault()

      // Fast menu update
      const menu = document.getElementById('editor-drag-drop-menu')
      if (menu) menu.style.visibility = 'visible'

      // Clean up areas

      // Set position based on drop location

      // Immediately handle data transfer
      const dataTransfer = domEvent.dataTransfer
      if (!dataTransfer) return

      // Execute callbacks
      onDropClose()

      // Fast path handlers based on data types
      const boxData = dataTransfer.getData('boxData')
      const dragData = dataTransfer.getData('dragDropData')
        ? JSON.parse(dataTransfer.getData('dragDropData'))
        : null

      if (dragData) {
        track('block_added', {
          category: boxData === 'media' ? 'video' : boxData,
          type: dragData.name,
        })
      }

      // Only proceed with modal actions if dropped on valid area
      // For activities and special image types (imageHotspot, imageCarousel), we allow dropping anywhere
      const isImageSpecialType = boxData === 'image' && dragData && (dragData.value === 'imageCarousel' || dragData.value === 'imageHotspot')
      if (!isValidDrop && boxData !== 'activities' && !isImageSpecialType) {
        return
      }

      if (
        boxData &&
        dragData &&
        boxData === 'embed' &&
        dragData &&
        dragData.value === 'scorm'
      ) {
        replacedropAreaWideContent(
          editor,
          dragData,
          boxData,
          dispatch,
          Embed,
          CommunityBoardModal,
          dataTransfer.getData('font'),
          dataTransfer.getData('language'),
          dataTransfer.getData('languageCode') || 'en',
          domEvent.target,
        )
      } else if (
        boxData &&
        dragData &&
        boxData === 'embed' &&
        dragData &&
        dragData.value !== 'elevenLabs'
      ) {
        handleAddEmbed(
          dragData,
          editor.model.document.selection,
          editor,
          dispatch,
          Embed,
        )
      } else if (boxData && dragData && (boxData === 'actions' || boxData === 'image')) {
        if (dragData.value === 'interactiveActivity') {
          track('interactive_activity_started')
          const currentUserType = UserType[
            window.CONSTANTS.USER_ROLE_ID
          ]?.trim()

          const freeAccountTypes = [
            'AppSumo (Tier 1)',
            'AppSumo (Tier 2)',
            'AppSumo (Tier 3)',
            'AppSumo (Tier 3A)',
            'AppSumo (Tier 2A)',
            'AppSumo (Tier 1A)',
          ]

          if (freeAccountTypes.includes(currentUserType)) {
            handleAddInterActiveFreeAccount(editor, dispatch)
          } else {
            handleAddInterActive(
              dragData,
              editor.model.document.selection,
              editor,
              dispatch,
              Embed,
              null,
              null,
              false,
              dataTransfer.getData('font'),
              dataTransfer.getData('language'),
            )
          }
        } else if (
          boxData &&
          dragData &&
          boxData === 'image' &&
          dragData.value === 'imageHotspot'
        ) {
          // Stop CKEditor's native DragDrop plugin from also processing this drop
          event.stop()

          // Get the drop area position from DOM
          const dropAreaNarrow = domEvent.target.closest('.drop-area-narrow')
          let position = editor.model.document.selection

          if (dropAreaNarrow) {
            // Find the model element for the drop area
            const viewElement = editor.editing.view.domConverter.domToView(dropAreaNarrow)
            if (viewElement) {
              const viewPosition = editor.editing.view.createPositionBefore(viewElement)
              const modelPosition = editor.editing.mapper.toModelPosition(viewPosition)
              if (modelPosition && modelPosition.nodeAfter) {
                editor.model.change(writer => {
                  const range = writer.createRangeOn(modelPosition.nodeAfter)
                  position = range.start
                  handleAddImageHotspot(
                    position,
                    editor,
                    {
                      src: dragData.imageUrl || 'https://cdn.minicoursegenerator.com/assets/carousel-and-hotspot/carouselAndHotspotImage.png',
                      alt: dragData.imageAlt || 'Hotspot Image',
                    },
                    writer,
                    modelPosition.nodeAfter,
                  )
                })
              } else {
                handleAddImageHotspot(
                  position,
                  editor,
                  {
                    src: dragData.imageUrl || 'https://cdn.minicoursegenerator.com/assets/carousel-and-hotspot/carouselAndHotspotImage.png',
                    alt: dragData.imageAlt || 'Hotspot Image',
                  },
                  null,
                  null,
                )
              }
            }
          } else {
            handleAddImageHotspot(
              position,
              editor,
              {
                src: dragData.imageUrl || 'https://cdn.minicoursegenerator.com/assets/carousel-and-hotspot/carouselAndHotspotImage.png',
                alt: dragData.imageAlt || 'Hotspot Image',
              },
              null,
              null,
            )
          }
        } else if (
          boxData &&
          dragData &&
          boxData === 'actions' &&
          dragData.value === 'communityBlock'
        ) {
          const currentUserType = UserType[
            window.CONSTANTS.USER_ROLE_ID
          ]?.trim()

          // Account types that HAVE access to Community Board
          const communityAccessTypes = [
            'Pro',
            'Elite',
            'AppSumo (Tier 5)',
            'AppSumo (Tier 6)',
            'AppSumo (Tier 7)',
            'AppSumo (Tier 8)',
            'AppSumo (Tier 9)',
            'Plus',
            'Pro v2',
            'Launch',
            'Essentials',
            'Growth',
            'Scale',
            'Enterprise',
          ]

          if (
            !communityAccessTypes.includes(currentUserType) &&
            !UserType.isTrialEquivalent(currentUserType)
          ) {
            handleAddCommunityBoardFreeAccount(editor, dispatch)
          } else {
            handleAddCommunityBoard(
              editor.model.document.selection,
              editor,
              dispatch,
              CommunityBoardModal,
              null,
              null,
            )
          }
        } else if (dragData.html) {
          // Handle other actions with HTML (like imageCarousel/Hotspot Carousel)
          event.stop()
          replacedropAreaWideContent(
            editor,
            dragData,
            boxData,
            dispatch,
            Embed,
            CommunityBoardModal,
            dataTransfer.getData('font'),
            dataTransfer.getData('language'),
            dataTransfer.getData('languageCode') || 'en',
            domEvent.target,
          )
        }
      } else if (
        boxData &&
        dragData &&
        boxData === 'activities'
      ) {
        console.log('🎮 Activities drop detected!', { boxData, dragData })

        // Find the actual drop target element (drop-area-narrow or drop-area-wide)
        let dropTargetElement = domEvent.target
        while (dropTargetElement && dropTargetElement !== document.body) {
          if (
            dropTargetElement.classList?.contains('drop-area-wide') ||
            dropTargetElement.classList?.contains('drop-area-narrow')
          ) {
            break
          }
          dropTargetElement = dropTargetElement.parentElement
        }

        console.log('🎯 Drop target element found:', dropTargetElement)

        // Debug: Log what we're about to pass
        const fontData = dataTransfer.getData('font')
        const languageData = dataTransfer.getData('language')
        const languageCode = dataTransfer.getData('languageCode') || 'en'

        console.log('📤 Data being passed to replacedropAreaWideContent:', {
          fontData,
          languageData,
          languageCode,
          dragData,
          boxData
        })

        // Handle Activities drag-drop using centralized function
        replacedropAreaWideContent(
          editor,
          dragData,
          boxData,
          dispatch,
          Embed,
          CommunityBoardModal,
          fontData,
          languageData,
          languageCode,
          dropTargetElement, // Pass the drop target element
        )
      } else {
        const element = dataTransfer.getData('element')
        if (element) {
          // Stop event to prevent CKEditor's Clipboard plugin from also processing this drop
          event.stop()

          editor.model.change(writer => {
            const newElement = createNestedElements(JSON.parse(element), writer)
            editor.model.insertContent(
              newElement,
              editor.model.document.selection,
            )

          })

        }
        setTimeout(() => {
          removeDropAreaNarrow(editor)
        }, 300)
        setTimeout(() => {
          removeAllDropAreas(editor)
        }, 500)
      }


    })
  }
}
const createNestedElements = (elementConfig, writer) => {
  const element = writer.createElement(
    elementConfig.name,
    elementConfig.attributes || {},
  )

  // Eğer bu simpleButton ise, text ve icon ekle
  if (elementConfig.name === 'simpleButton') {
    const text = writer.createText(elementConfig.attributes.text || 'Button')
    const simpleIcon = writer.createElement('simpleIcon', {
      icon: elementConfig.attributes.icon || '',
    })

    writer.append(simpleIcon, element)
    writer.append(text, element)
  }
  // Normal children ekleme işlemi
  else if (elementConfig.children && elementConfig.children.length > 0) {
    elementConfig.children.forEach(childConfig => {
      const childElement = createNestedElements(childConfig, writer)
      writer.append(childElement, element)
    })
  }

  return element
}

// Font Size Calculate

export const calculateFontSize = (baseSize, sizeModifier = null) => {
  const sizeMap = {
    XS: -4,
    S: -2,
    M: 0,
    L: 2,
    XL: 4,
  }

  return baseSize + (sizeModifier ? sizeMap[sizeModifier] : 0)
}

export const replaceContentById = (id, newHtml) => {
  const currentData = window.editor.getData()
  const parser = new DOMParser()
  const doc = parser.parseFromString(currentData, 'text/html')

  const targetElement = doc.querySelector(`[id="${id}"]`)
  if (!targetElement) {
    return false
  }
  targetElement.innerHTML = newHtml

  const updatedContent = doc.body.innerHTML

  window.editor.setData(updatedContent)

  return true
}

/**
 * @param {object} editor - CKEditor instance
 * @param {object} audioData - { src: string, id?: string|null }
 * @param {object} [position]
 */
export function insertSingleAudioBox(editor, audioData, position) {
  try {
    editor.model.change(writer => {
      const selection = editor.model.document.selection
      let audioElement = null

      if (
        selection.getSelectedElement() &&
        selection.getSelectedElement().is('element', 'textToSpeech')
      ) {
        audioElement = selection.getSelectedElement()
      } else {
        for (const item of selection.getFirstRange()) {
          if (item.item.is('element', 'textToSpeech')) {
            audioElement = item.item
            break
          }
        }
      }

      if (audioElement) {
        // Mevcut elementi güncelle
        writer.setAttribute('src', audioData.src, audioElement)
        if (audioData.id !== undefined && audioData.id !== null) {
          writer.setAttribute('id', audioData.id, audioElement)
        }
        writer.setSelection(audioElement, 'on')
      } else {
        // Yeni element oluştur
        const wrapper = writer.createElement('simpleBoxWrapper')
        const simpleBox = writer.createElement('simpleBox')
        const column = writer.createElement('column')
        const ttsAttrs = {
          type: 'single',
          src: audioData.src,
        }
        if (audioData.id !== undefined && audioData.id !== null) {
          ttsAttrs.id = audioData.id
        }
        const tts = writer.createElement('textToSpeech', ttsAttrs)

        writer.append(tts, column)
        writer.append(column, simpleBox)
        writer.append(simpleBox, wrapper)

        if (position && position.root) {
          editor.model.insertContent(wrapper, position)
        } else {
          editor.model.insertContent(wrapper)
        }

        writer.setSelection(tts, 'on')
      }
    })
  } catch (error) {
    console.error('Audio box operation failed:', error)
    alert('Audio box could not be processed!')
  }
}
